import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import emailjs from '@emailjs/browser'
import './index.css'
import App from './App.tsx'

emailjs.init('y459mQFz3zIKOmCR8')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
